module.exports = __webpack_public_path__ + "static/lahli_spinach_rustica_marquee_600x622-50e45b7588c58bb7d5fe4a779633adc4.png";